import { Component, Input } from '@angular/core';
import { SvgLoaderComponent } from '../svg-loader/svg-loader.component';
import { CommonModule } from '@angular/common';
import { imgIxParams } from 'app/constants/img-ix-params';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [SvgLoaderComponent, CommonModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
export class AvatarComponent {
  @Input() size: string = '33px';
  @Input() imgURL: string;

  optimizedProfileImgURL: string = null;
  iconSize: string = '18px';

  ngOnInit() {
    this.optimizedProfileImgURL = this.imgURL ? this.imgURL + imgIxParams.profile.md : null;
    const parsed = parseInt(this.size.replace('px', '').trim(), 10);
    if (parsed < 24) {
      this.iconSize = "13px";
    }
  }

}
